import { Skeleton } from '@/shared/ui/Skeleton';
import { cn } from '@/utils/style';
import React from 'react';

interface QnaNativeSkeletonProps {
  className?: string;
  isShowAdBadge?: boolean;
}

const QnaNativeSkeleton: React.FC<QnaNativeSkeletonProps> = (props) => {
  const isShowAdBadge = props.isShowAdBadge ?? true;

  return (
    <>
      <div className='w-full border-gray-200 hover:bg-gray-30'>
        <div className='min-h-0'>
          <div className={cn('relative', props.className)}>
            <div className='box-border flex flex-col gap-[24px] p-[24px]'>
              <div className='absolute inset-x-0 bottom-0 border-gray-200 border-b' />
              <div className='flex flex-col gap-[12px]'>
                <div className='flex flex-col gap-[12px]'>
                  <div className='flex flex-col'>
                    <div className='mb-[12px] flex w-full items-center justify-between'>
                      <div className='flex flex-1 flex-col gap-[4px] pr-[16px]'>
                        <Skeleton className='h-[24px] w-[60%] rounded-[4px]' />
                        <div className='flex flex-col'>
                          <Skeleton className='h-[18px] w-[85%] rounded-[4px]' />
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center gap-[4px]'>
                      <Skeleton className='h-[24px] w-[60px] rounded-[4px]' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* AD 배지 */}
            {isShowAdBadge && (
              <div className='absolute top-[12px] right-[12px] flex h-[18px] w-[28px] items-center justify-center rounded-[5px] bg-gray-200'>
                <Skeleton className='h-[18px] w-[28px] rounded-[2px]' />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='h-[1px] w-full bg-gray-40' />
    </>
  );
};

export default QnaNativeSkeleton;
